import { Injectable } from '@angular/core';
import { environment } from 'src/app/environment';
import { URL_API } from 'src/app/tools/URL';
import { RestService } from '../rest.service';

@Injectable({
  providedIn: 'root'
})
export class BancoService {

  constructor(private rest: RestService) { }

  carregarDados() {

    return this.rest.get(`${URL_API.PATH_CARREGAR_BANCOS}`);

  }

}
